import { LucideIcon } from '@skin-seoul/design-system';
import { ReviewVideoPoster } from './ReviewVideoPoster';

/** The mark reads as a control rather than an ornament at a little over half the circle. */
const PLAY_ICON_RATIO = 0.55;

interface ReviewVideoThumbnailProps {
  url: string;
  playMarkSize: number;
  className?: string;
  onClick?: (event: React.MouseEvent) => void;
}

/** `<img>` renders a clip as a broken thumbnail, and an unmarked poster frame reads as a photo. */
export const ReviewVideoThumbnail = ({
  url,
  playMarkSize,
  className = 'w-full h-full object-cover',
  onClick,
}: ReviewVideoThumbnailProps) => {
  const iconSize = `${Math.round(playMarkSize * PLAY_ICON_RATIO)}px`;
  // Its own dark backing: a light scrim disappears against a bright first frame.
  const markClassName =
    'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-full bg-[rgba(0,0,0,0.45)] backdrop-blur-[8px]';
  const mark = <LucideIcon name="Play" width={iconSize} height={iconSize} className="text-generic-0 fill-generic-0" />;

  return (
    <div className="relative flex items-center justify-center w-full h-full">
      <ReviewVideoPoster url={url} className={className} onClick={onClick} />
      {/* Only a mark where nothing plays: a button announcing "Play review video" that opens the
          review instead is a control that lies about what it does. */}
      {onClick ? (
        <button
          type="button"
          aria-label="Play review video"
          onClick={onClick}
          className={markClassName}
          style={{ width: playMarkSize, height: playMarkSize }}
        >
          {mark}
        </button>
      ) : (
        <span aria-hidden="true" className={markClassName} style={{ width: playMarkSize, height: playMarkSize }}>
          {mark}
        </span>
      )}
    </div>
  );
};

export default ReviewVideoThumbnail;
